import Row from '@sdk/components/ui/spacing/Row';
import Column from '@sdk/components/ui/spacing/Column';
import H5 from '@sdk/components/ui/typography/H5';
import Text14 from '@sdk/components/ui/typography/Text14';
import Text16 from '@sdk/components/ui/typography/Text16';
import gettext from '@sdk/lang/gettext';
import CloseIcon from '@sdk/components/ui/CloseIcon';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import {
  BannerContainer,
  BannerTextColumn,
  BannerButton,
} from '@web/settings/components/ICalPreferencesBanner/iCalPreferencesBanner.styles';
import { useNavigation } from '@web/navigation/NavigationProvider';
import { useSettingsClientFlags } from '@web/settings/SettingsClientFlagsContext';
import GoogleCalendarDeprecationSvg from '@web/assets/svg/images/google-calendar-deprecation.svg';

const ICalPreferencesBanner = () => {
  const { navigate } = useNavigation();
  const { clientFlags, saveClientFlags } = useSettingsClientFlags();

  if (clientFlags.iCalPreferencesBannerDismissed) {
    return null;
  }

  const dismiss = () => {
    saveClientFlags({
      flags: {
        iCalPreferencesBannerDismissed: true,
      },
    });
  };

  const goToSchedule = () => {
    dismiss();
    navigate('shifts');
  };

  return (
    <>
      <BannerContainer>
        <BannerTextColumn>
          <H5 themeColor={ThemeColorType.primary}>
            {gettext('Looking for Google calendar synchronization?')}
          </H5>
          <Text16 themeColor={ThemeColorType.gray}>
            {gettext('We got something better for you ✨')}
          </Text16>
          <Row mTop={20}>
            <Text14 themeColor={ThemeColorType.gray}>
              {gettext(
                "Now you'll be able to sync your shifts to any calendar tools you use to overlay your work schedules on top of your existing personal calendar."
              )}
            </Text14>
          </Row>
          <Row mTop={20}>
            <BannerButton buttonType={ButtonType.primary} onClick={goToSchedule}>
              {gettext('Try it now')}
            </BannerButton>
          </Row>
        </BannerTextColumn>
        <GoogleCalendarDeprecationSvg />
        <Column mTop={-30} mRight={-40}>
          <CloseIcon spacing={20} onClick={dismiss} />
        </Column>
      </BannerContainer>
      <Row mBottom={20} mTop={20}>
        <HorizontalSeparator />
      </Row>
    </>
  );
};

export default ICalPreferencesBanner;
